import React, { useState, useCallback, useEffect, useRef } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import { Form } from "@unform/web";
import Input from "../../components/Input";
import PageHeader from "../../components/PageHeader";
import { Title, PageWrapper } from "../../settings/layout";
import {
    CreateExpenseContainerIcons,
    CreateExpenseButtonContainer,
} from "./styles";
import { InputLabel } from "../../components/Input/styles";
import Button from "../../components/Button";
import Icons from "../../components/Icons";
import { connect } from "react-redux";
import {
    Creators as ExpensesActions,
    IExpenseStore,
} from "../../store/ducks/expenses";
import { Dispatch, bindActionCreators } from "redux";
import IExpensesActions from "../../interfaces/IReduxActions";
import IExpense from "../../interfaces/IExpense";
import { v4 as uuidv4 } from "uuid";
import { RouteComponentProps } from "react-router";
import IReduxStore from "../../interfaces/IReduxStore";
import { string, number, object, ValidationError } from "yup";
import history from "../../services/history";

interface IProps extends RouteComponentProps<{ uuid: string }> {
    expensesActions: IExpensesActions;
    expenses: IExpenseStore;
}

const schema = object().shape({
    amount: number()
        .typeError("Apenas números são permitidos.")
        .required("Campo obrigatório."),
    category: string().required("Campo obrigatório."),
});

const icons = ["food", "car", "beer"];

const CreateExpense = ({ expensesActions, expenses, match }: IProps) => {
    const [selectedIcon, setSelectedIcon] = useState(icons[0]);
    const [initialData, setInitialData] = useState<IExpense>();

    const formRef = useRef<any>(null);

    const { uuid } = match.params;

    const getExpenseByUuid = useCallback(() => {
        try {
            if (!uuid) {
                throw new Error();
            }
            const expense = expenses.items.find(
                (expense) => expense.uuid === uuid
            );

            if (!expense) {
                history.push({ pathname: `/app` });
                throw new Error("not found");
            }

            setSelectedIcon(expense.icon);

            setInitialData(expense);
        } catch (error) {
            console.log(error);
        }
    }, [expenses.items, uuid]);

    useEffect(() => getExpenseByUuid(), [getExpenseByUuid]);

    const handleSubmit = useCallback(
        async (data: { amount: number; category: string }) => {
            try {
                // Remove all previous errors
                if (!!formRef && !!formRef.current) {
                    formRef.current.setErrors({});
                }

                await schema.validate(data, {
                    abortEarly: false,
                });

                const formatBody: IExpense = {
                    ...data,
                    icon: selectedIcon,
                    created: new Date().toISOString(),
                    uuid: !!uuid ? uuid : uuidv4(),
                };

                expensesActions.createExpenseRequest(formatBody);
            } catch (err) {
                console.log(err);

                const validationErrors: any = {};
                if (err instanceof ValidationError) {
                    err.inner.forEach((error) => {
                        validationErrors[error.path] = error.message;
                    });
                    formRef.current.setErrors(validationErrors);
                }
            }
        },
        [expensesActions, selectedIcon, uuid]
    );

    const handleClickDelete = useCallback(() => {
        if (!uuid) {
            return;
        }

        expensesActions.deleteExpenseRequest({ uuid });
    }, [expensesActions, uuid]);

    console.log("expenses", expenses);

    return (
        <PageWrapper>
            <PageHeader>
                <Breadcrumb
                    links={[
                        { name: "Home", path: "/app" },
                        {
                            name: "Adicionar Gasto",
                            path: "/app/gasto/adicionar",
                            active: true,
                        },
                    ]}
                />

                <Title>{!!uuid ? "Editar" : "Adicionar"} gasto</Title>
            </PageHeader>

            <Form
                ref={formRef}
                onSubmit={handleSubmit}
                style={{ display: "contents" }}
                initialData={initialData}
            >
                <Input name="amount" type="number" label="Valor" step="0.01" />
                <Input name="category" type="text" label="Categoria" />

                <InputLabel>Icone</InputLabel>
                <CreateExpenseContainerIcons>
                    {icons.map((icon) => (
                        <Button
                            type="button"
                            rounded
                            variant={icon === selectedIcon ? "Info" : "Ink"}
                            key={icon}
                            onClick={() => setSelectedIcon(icon)}
                        >
                            <Icons name={icon} width={20} height={20} />
                        </Button>
                    ))}
                </CreateExpenseContainerIcons>

                <CreateExpenseButtonContainer>
                    {!!uuid && (
                        <Button
                            variant="Danger"
                            type="button"
                            style={{ marginRight: "10px" }}
                            onClick={handleClickDelete}
                        >
                            Excluir
                        </Button>
                    )}

                    <Button
                        variant="Success"
                        type="submit"
                        disabled={!selectedIcon}
                    >
                        {!!uuid ? "Atualizar" : "Adicionar"}
                    </Button>
                </CreateExpenseButtonContainer>
            </Form>
        </PageWrapper>
    );
};

const mapStateToProps = ({ expenses }: IReduxStore) => ({
    expenses,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    expensesActions: bindActionCreators(ExpensesActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateExpense);
